<template>
	<Modal :id="id">
		<div slot="header" class="modal-header">
			<h3 class="modal-title font-weight-bold text-dark">Help/Feedback Form</h3>
			<a
				class="icon icon-remove text-right text-dark"
				@click.prevent="close()"
				data-dismiss="modal"
				aria-label="Close"
			></a>
		</div>
		<div slot="body" class="modal-body modal-form">
			<a href="#" class="close" @click.prevent="close"></a>
			<transition name="fade">
				<Alert v-if="hasAlert" :alert="alert"/>
			</transition>
			<div class="form-group">
				<Field
					type="text"
					label="Your Email"
					name="email"
					v-model="email"
					validate="required"
				/>
			</div>
			<div class="form-group">
				<Field
					type="textarea"
					label="Enter your questions and/or comments below"
					name="comments"
					v-model="comments"
					validate="required"
				/>
			</div>
		</div>
		<div slot="footer" class="modal-footer">
			<a
				class="btn btn-success ga-event"
				data-ga-category="Forms"
				data-ga-action="feedback-form"
				data-ga-label="Feedback Form"
				href="#"
				@click.prevent="send"
			>Send</a
			>
			<a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
		</div>
	</Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import DisplaysAlerts from "mixins/DisplaysAlerts";

export default {
	mixins: [ModalMixin, DisplaysAlerts],
	data() {
		return {
			id: "contact-modal",
			email: this.$root.isLoggedIn ? this.$root.user.email : "",
			comments: "",
		};
	},
	methods: {
		send() {
			this.axios
				.post(this.route("help.feedback"), {
					email: this.email,
					comments: this.comments,
				})
				.then(() => {
					this.showAlert(
						"success",
						"Thank you for your feedback! We will be in touch soon."
					);
				});
		},
	},
};
</script>
<style>
.modal-body a.close {
	text-transform: uppercase;
	position: absolute;
	right: 5px; top: 5px;
}
</style>